module.exports = __webpack_public_path__ + "img/post-germany-cod.755554a5.png";